import ClickImpressionClickSortWrap from "./ClickImpressionClickSortWrap";

const ClickImpressionClick = () => {
  return (
    <>
      <ClickImpressionClickSortWrap />
    </>
  );
};

export default ClickImpressionClick;
